/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HostNameApiIdCredentialData
 */
export interface HostNameApiIdCredentialData {
    /**
     * 
     * @type {string}
     * @memberof HostNameApiIdCredentialData
     */
    hostName?: string;
    /**
     * 
     * @type {string}
     * @memberof HostNameApiIdCredentialData
     */
    apiId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof HostNameApiIdCredentialData
     */
    apiKeyConfigured?: boolean;
}

/**
 * Check if a given object implements the HostNameApiIdCredentialData interface.
 */
export function instanceOfHostNameApiIdCredentialData(value: object): value is HostNameApiIdCredentialData {
    return true;
}

export function HostNameApiIdCredentialDataFromJSON(json: any): HostNameApiIdCredentialData {
    return HostNameApiIdCredentialDataFromJSONTyped(json, false);
}

export function HostNameApiIdCredentialDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): HostNameApiIdCredentialData {
    if (json == null) {
        return json;
    }
    return {
        
        'hostName': json['hostName'] == null ? undefined : json['hostName'],
        'apiId': json['apiId'] == null ? undefined : json['apiId'],
        'apiKeyConfigured': json['apiKeyConfigured'] == null ? undefined : json['apiKeyConfigured'],
    };
}

export function HostNameApiIdCredentialDataToJSON(json: any): HostNameApiIdCredentialData {
    return HostNameApiIdCredentialDataToJSONTyped(json, false);
}

export function HostNameApiIdCredentialDataToJSONTyped(value?: HostNameApiIdCredentialData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'hostName': value['hostName'],
        'apiId': value['apiId'],
        'apiKeyConfigured': value['apiKeyConfigured'],
    };
}

